<template>
  <v-row justify="center">
    <signature-pad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="signatureData"
    />

    <v-dialog v-model="dialog" persistent max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ item.medication }}</span>
          <v-spacer></v-spacer>
          <v-btn
            fab
            dark
            small
            :loading="isDownloading"
            color="blue-grey"
            @click="downloadItem"
          >
            <v-icon dark> mdi-cloud-download </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row class="mb-3" v-if="false">
              <div class="d-flex align-center">
                <v-menu offset-y class="ma-0 pa-0">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-2"
                      color="indigo darken-4"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      Filter By

                      <v-icon right dark> mdi-filter-variant </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-for="(item, index) in dateMenu" :key="index">
                      <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-text-field
                  label="Legal middle name"
                  outlined
                  dense
                  hide-details
                  class="mr-3"
                ></v-text-field>
                <v-text-field
                  label="Legal middle name"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
                <v-btn class="ml-2" color="primary">Search</v-btn>
              </div>
            </v-row>

            <v-row class="mt-3">
              <v-col cols="12" class="pa-0 ma-0">
                <template>
                  <v-data-table
                    :headers="headers"
                    :items="getInventoryLogItems"
                    :items-per-page="5"
                    :loading="isLoading"
                    class="elevation-1"
                    :item-class="rowColor"
                  ></v-data-table>
                </template>
              </v-col>
            </v-row>

            <v-row class="mt-10">
              <v-text-field label="Verified By"></v-text-field>
            </v-row>
          </v-container>
        </v-card-text>
        <div>
          <v-container>
            <v-img
              v-if="staffDigitalSignature"
              max-height="80"
              max-width="150"
              :src="staffDigitalSignature"
            ></v-img>
          </v-container>
        </div>

        <v-card-actions>
          <v-btn
            class="white--text"
            color="primary"
            @click.stop="showSignaturePad = true"
          >
            <div class="text-caption text-sm-body-1">
              Verifier Signature
            </div></v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close"> Close </v-btn>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SignaturePad from "@/components/SignaturePad";
import download from "downloadjs";

export default {
  props: {
    item: {
      type: Object,
    },
  },
  components: {
    SignaturePad,
  },
  data: () => ({
    headers: [
      {
        text: "Date",
        align: "start",
        sortable: false,
        value: "createdAt",
      },
      { text: "Time", value: "mar.AdminTime" },
      { text: "Amount Present", value: "presentAmount" },
      { text: "Amount Recieved or Passed", value: "amount" },
      { text: "Amount Remaining", value: "amountRemaining" },
      { text: "Comment (Count/Pass)", value: "transactionType" },
      { text: "MC", value: "signature" },
      { text: "MV", value: "verifiedBy" },
    ],
    dateMenu: ["Month", "Date"],
    isLoading: false,
    isDownloading: false,
    staffDigitalSignature: "",
    showSignaturePad: false,
    itemId: "",
  }),

  computed: {
    ...mapGetters({
      getInventoryLogItems: "medicationInventory/getInventoryLogItems",
      getPDFDocument: "medicationInventory/getPDFDocument",
    }),
    dialog: {
      get() {
        return this.$store.state.medicationInventory.dialog;
      },
      set(val) {
        this.$store.commit("medicationInventory/SET_DIALOG", val);
      },
    },
  },
  methods: {
    ...mapActions({
      getInventoryLogs: "medicationInventory/getInventoryLogs",
    }),

    onViewItem(item) {
      this.itemId = item._id;
      this.getInventoryLogs({
        id: this.itemId,
        download: false,
      });
    },

    async downloadItem() {
      try {
        this.isDownloading = true;
        await this.getInventoryLogs({
          id: this.itemId,
          download: true,
        });

        download(this.getPDFDocument, "cscs.pdf", "application/pdf");
        this.isDownloading = false;
      } catch (error) {
        console.log(error);
      }
    },

    signatureData(data) {
      this.staffDigitalSignature = data;
    },

    close() {
      this.dialog = false;
      this.clear();
    },

    clear() {
      this.staffDigitalSignature = "";
    },

    rowColor(item) {
      switch (item.transactionType) {
        case "Pass":
          return "red lighten-5"; // CSS class for "pass" comment
        case "Count":
          return "light-blue lighten-5"; // CSS class for "count" comment
        case "Count (New Cycle)":
          return "green lighten-5"; // CSS class for "cycle" comment
        default:
          return "none"; // Default row class if none of the conditions match
      }
    },
  },
};
</script>

<style scoped>
.btn-container {
  display: flex;
  padding-left: 0;
}
</style>
